var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "bg-light pt-3" },
    [
      _c("div", { staticClass: "row mb-3" }, [
        _c(
          "div",
          { staticClass: "col-12 col-md-8 offset-md-2" },
          [
            _c(
              "router-link",
              {
                staticClass: "text-primary-link",
                attrs: {
                  to: _vm.isLineLoggedIn
                    ? "/line-liff/bookings"
                    : "/my-reservations"
                }
              },
              [_vm._v(_vm._s(_vm.$t("message.menu.my_reservations")))]
            ),
            _vm._v(" "),
            _c("i", { staticClass: "fal fa-angle-right" }),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "text-primary-link",
                attrs: { to: "/reservation/" + _vm.orderId }
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("message.my_reservations.reservation_detail"))
                )
              ]
            ),
            _vm._v(" "),
            _c("i", { staticClass: "fal fa-angle-right" }),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("message.my_reservations.payment")) +
                "\n    "
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.order.bank_transfer_data
        ? [
            _c("div", { staticClass: "row success-booking" }, [
              _c("div", { staticClass: "col-12 col-lg-6 offset-lg-3" }, [
                _c("div", { staticClass: "text-center p-2 text-center" }, [
                  _vm.order.paid_status === 0
                    ? _c("img", {
                        attrs: {
                          src: "/static/img/ic-waiting-confirmation.svg",
                          width: "90"
                        }
                      })
                    : _c("i", {
                        staticClass:
                          "fal fa-check-circle fa-5x -status-accepted"
                      }),
                  _vm._v(" "),
                  _c("h2", { staticClass: "pt-4 m-0" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm._f("currency")(
                            _vm.order.order_summary_total.total
                          )
                        ) +
                        "\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", [
                      _vm.order.paid_status === 0
                        ? _c("span", [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message.bank_transfer.complete_bank_transfer"
                                  )
                                )
                              )
                            ])
                          ])
                        : _c("span", [
                            _c("b", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "message.qr_payment.payment_successful"
                                  )
                                )
                              )
                            ])
                          ])
                    ]),
                    _vm._v(" "),
                    _c("hr"),
                    _vm._v(" "),
                    _c("div", { staticClass: "row no-gutters pb-2" }, [
                      _c("div", { staticClass: "col-6" }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.qr_payment.payment_method"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-6 text-right" }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.payment_method.bank_transfer"))
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.order.order_summary_total.reconcile_date
                      ? _c("div", { staticClass: "row no-gutters pb-2" }, [
                          _c("div", { staticClass: "col-6" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("message.qr_payment.transaction_date")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "col-6 text-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("prettyDate")(
                                  _vm.order.order_summary_total.reconcile_date
                                )
                              )
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "row no-gutters" }, [
                      _c("div", { staticClass: "col-6" }, [
                        _vm._v(_vm._s(_vm.$t("message.qr_payment.order_id")))
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-6 text-right" }, [
                        _vm._v("#" + _vm._s(_vm.order.order_code))
                      ])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "pt-2" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "btn btn-info btn-block",
                        attrs: { to: "/reservation/" + _vm.order.id, tag: "a" }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.$t(
                                "message.booking.complete_step.view_my_booking"
                              )
                            ) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ])
          ]
        : [
            _vm.order.is_expired_bank_transfer === 1
              ? [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-lg-6 offset-lg-3" }, [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-body text-center" }, [
                          _c("i", {
                            staticClass: "fal fa-frown fa-4x -status-new"
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-3 mb-3" }, [
                            _c("h4", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("message.my_reservations.booking")
                                ) +
                                  " #" +
                                  _vm._s(_vm.order.order_code)
                              )
                            ]),
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.$t(
                                    "message.bank_transfer.expired_bank_transfer"
                                  )
                                ) +
                                "\n              "
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ]
              : [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-8 offset-md-2" }, [
                      _vm.globalState
                        ? _c("div", { staticClass: "card" }, [
                            _c("div", { staticClass: "card-body" }, [
                              _c("h3", { staticClass: "text-center py-2" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("message.bank_transfer.title"))
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$options.filters.bankTransferDurationText(
                                      _vm.order,
                                      _vm.globalState
                                    )
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _vm.order.selected_professional_id > 0
                                ? _c("div", { staticClass: "mt-3" }, [
                                    _c("img", {
                                      directives: [
                                        {
                                          name: "lazy",
                                          rawName: "v-lazy",
                                          value: _vm.order.professional_picture,
                                          expression:
                                            "order.professional_picture"
                                        }
                                      ],
                                      staticClass: "rounded-circle",
                                      attrs: { width: "40" }
                                    }),
                                    _vm._v(
                                      "\n                 " +
                                        _vm._s(
                                          _vm._f("firstName")(
                                            _vm.order.professional_name
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ])
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-8 offset-md-2" }, [
                      _c("div", { staticClass: "card" }, [
                        _c(
                          "div",
                          { staticClass: "card-body" },
                          [
                            _vm.order
                              ? [
                                  _c(
                                    "section",
                                    { staticClass: "mt-3" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "text-left mt-4" },
                                        [
                                          _c("order-summary-detail", {
                                            attrs: { order: _vm.order }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("order-summary-total-short", {
                                        attrs: { order: _vm.order }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("hr")
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c("section", { staticClass: "mt-4" }, [
                              _c("div", { staticClass: "row mb-3" }, [
                                _c("div", { staticClass: "col" }, [
                                  _c("h4", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("message.bank_transfer.detail")
                                      )
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row mb-3" }, [
                                _c("div", { staticClass: "col-12 col-md-3" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.bank_transfer.transfer_account"
                                        )
                                      )
                                    )
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12 col-md-9" }, [
                                  _c("div", [
                                    _c("img", {
                                      staticClass: "mb-2",
                                      attrs: {
                                        src:
                                          _vm.globalState.bankAccountData
                                            .image_url,
                                        width: "160"
                                      }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.bank_transfer.account_name"
                                        )
                                      ) +
                                        ": " +
                                        _vm._s(
                                          _vm._f("multiLangName")(
                                            _vm.globalState.bankAccountData
                                          )
                                        ) +
                                        "\n                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex align-items-center justify-content-center"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "flex-grow-1" },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "message.bank_transfer.account"
                                                )
                                              ) +
                                                ": " +
                                                _vm._s(
                                                  _vm.globalState
                                                    .bankAccountData
                                                    .account_number
                                                ) +
                                                "\n                        "
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "text-right" }, [
                                        _c(
                                          "button",
                                          {
                                            directives: [
                                              {
                                                name: "clipboard",
                                                rawName: "v-clipboard:copy",
                                                value:
                                                  _vm.globalState
                                                    .bankAccountData
                                                    .account_number,
                                                expression:
                                                  "globalState.bankAccountData.account_number",
                                                arg: "copy"
                                              }
                                            ],
                                            staticClass: "btn btn-outline-info",
                                            on: {
                                              click: function($event) {
                                                _vm.isCopied = true
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                          " +
                                                _vm._s(
                                                  _vm.isCopied
                                                    ? _vm.$t(
                                                        "message.button.copied"
                                                      )
                                                    : _vm.$t(
                                                        "message.button.copy"
                                                      )
                                                ) +
                                                "\n                        "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "row mb-3" }, [
                                _c("div", { staticClass: "col-12 col-md-3" }, [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "message.bank_transfer.transfer_picture"
                                        )
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "text-danger" }, [
                                    _vm._v("*")
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12 col-md-9" }, [
                                  !_vm.uploadSuccess
                                    ? _c(
                                        "div",
                                        [
                                          _c("vue-dropzone", {
                                            ref: "vueDropzone",
                                            staticClass: "dropzone-dashed",
                                            attrs: {
                                              id: "dropzone",
                                              options: _vm.dropzoneOptions
                                            },
                                            on: {
                                              "vdropzone-max-files-exceeded":
                                                _vm.vueDropZoneMaxFilesExceeded,
                                              "vdropzone-mounted":
                                                _vm.vueDropZoneMounted,
                                              "vdropzone-success":
                                                _vm.vueDropZoneSuccess
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "text-remark py-2" },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.bank_transfer.transfer_picture_remark01"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-info btn-block",
                                              on: {
                                                click: function($event) {
                                                  return _vm.performUpload()
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                        " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "message.button.submit"
                                                    )
                                                  ) +
                                                  "\n                      "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _c("div", [
                                        _c("i", {
                                          staticClass:
                                            "fas fa-check-circle -status-accepted"
                                        }),
                                        _vm._v(
                                          "\n                      " +
                                            _vm._s(
                                              _vm.$t(
                                                "message.bank_transfer.upload_success"
                                              )
                                            ) +
                                            "\n                    "
                                        )
                                      ])
                                ])
                              ])
                            ])
                          ],
                          2
                        )
                      ])
                    ])
                  ])
                ]
          ],
      _vm._v(" "),
      _vm.isLineLoggedIn
        ? _c(
            "div",
            { staticClass: "container text-center pt-3 pb-4" },
            [
              _c(
                "router-link",
                { attrs: { to: "/reservation/" + _vm.order.id } },
                [
                  _c("i", { staticClass: "fas fa-angle-left" }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("message.booking.new_booking.back")) +
                      "\n    "
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-062c1de6", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-062c1de6","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order/ConfirmBankTransfer.vue
// module id = 1781
// module chunks = 0